module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon-57x57.4581aaf073f25eed03d5b5e2e3e6830a.png";